export const pushAction = (state, {action}) => {
  state.queue.push(action)
}

export const setIsWorking = state => {
  console.assert(!state.isWorking, 'should not work')
  state.isWorking = true
}
export const unsetIsWorking = state => {
  console.assert(state.isWorking, 'should work')
  state.isWorking = false
}

export const setCurrentActionMessage = (state, {message}) => {
  if (message) {
    console.debug('Current action: ', message)
  }
  state.currentActionMessage = message
}



// WEBPACK FOOTER //
// ./src/store/queue/mutations.js